/** @jsxImportSource @emotion/react */
// Re-export from ImageManagement for backwards compatibility
import { ManualImages } from "./ImageManagement/ManualImages";

export { ManualImage } from "./ImageManagement/ManualImage";
export type { ManualImageProps } from "./ImageManagement/ManualImage";
export { ManualImages } from "./ImageManagement/ManualImages";
export type { ManualImagesProps } from "./ImageManagement/ManualImages";

// Default export for backwards compatibility
export default ManualImages;
